module.exports = __webpack_public_path__ + "static/media/logo-section-checkerboard.fd67e4e2.svg";